module.exports = __webpack_public_path__ + "static/media/Verification-graphics.08558ba9.png";